'use strict';

var React = require('react');
var Calendar = require('react-calendar');
require('../../../theme/breakpoints.js');
require('imask');
require('resize-observer-polyfill');
var useValidityState = require('../../../hooks/useValidityState.js');
var date = require('../../../helpers/date.js');
var index = require('../../Flex/index.js');
var component = require('../../Icon/component.js');
require('../../Tooltip/component.js');
var component$1 = require('../../Text/component.js');
var Small_styles = require('./Small.styles.js');
var useReactCalendar = require('./useReactCalendar.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var Calendar__default = /*#__PURE__*/_interopDefaultCompat(Calendar);

const CalendarMonthSmall = ({ value, onChange, showWeekNumbers = false, locale, month, formatMonth = date.formatMonth, onMonthChange, min, max, isUTC = true, valueIsRange = false, required = false, onValidityChange, }) => {
    const reactCalendarProps = useReactCalendar.useReactCalendar({ isUTC, month, onMonthChange, value, onChange, min, max });
    const formatReactCalendarWeekday = React.useCallback((theLocale, date$1) => date.formatWeekday(date$1, theLocale), []);
    const valueAsArray = React.useMemo(() => (Array.isArray(value) ? value : [value]).filter(Boolean), [value]);
    useValidityState.useValidityState({
        onValidityChange,
        getState: React.useCallback(() => ({
            valueMissing: required && valueAsArray.length === 0,
            rangeUnderflow: valueAsArray.length > 0 && min && valueAsArray.some(date.isBeforeDay(min)),
            rangeOverflow: valueAsArray.length > 0 && max && valueAsArray.some(date.isAfterDay(max)),
        }), [required, valueAsArray, min, max]),
    });
    return (React__default.default.createElement(index.Flex.Column, { space: "m" },
        React__default.default.createElement(Small_styles.GlobalStyle, null),
        React__default.default.createElement(index.Flex.Row, { space: "m", justifyContent: "space-between" },
            React__default.default.createElement(Small_styles.Styled.IconContainer, null,
                React__default.default.createElement(component.Icon, { name: "back-filled", onClick: () => onMonthChange(date.addMonths(-1, { isUTC })(month)), "aria-label": "previous month", role: "button" })),
            React__default.default.createElement(component$1.Text, { variant: "body", textTransform: "capitalize" }, formatMonth(month, locale)),
            React__default.default.createElement(Small_styles.Styled.IconContainer, null,
                React__default.default.createElement(component.Icon, { name: "next-filled", onClick: () => onMonthChange(date.addMonths(1, { isUTC })(month)), "aria-label": "next month", role: "button" }))),
        React__default.default.createElement(Calendar__default.default, { ...reactCalendarProps, showNavigation: false, locale: locale, formatShortWeekday: formatReactCalendarWeekday, selectRange: valueIsRange, showWeekNumbers: showWeekNumbers, view: "month" })));
};

exports.CalendarMonthSmall = CalendarMonthSmall;
//# sourceMappingURL=Small.js.map
